import ApplicationSerializer from 'eflex/serializers/application';

export default class KineticIssuedMaterialSerializer extends ApplicationSerializer {
  attrs = {
    issuedQuantities: {
      embedded: 'always',
    },
  };
}
